import axiosInstance from '@/api/axiosInstance';
import { CreateSkillPayload, CreateSkillResponse } from './types';

/**
 * Create a new skill
 * POST /api/learning-center/skills
 * Requires ROLE_LEARNING_ADMIN or ROLE_SUPER_ADMIN
 */
export const createSkill = async (
  payload: CreateSkillPayload
): Promise<CreateSkillResponse> => {
  try {
    const response = await axiosInstance.post<CreateSkillResponse>(
      '/api/learning-center/skills',
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating skill:', error);
    throw error;
  }
};
